<label class="font-label-text">Request Reconnect Date:</label>
<p-datepicker class="small-calendar" [(ngModel)]="reconnectSelectedDate" [showIcon]="true" class="calender-icon"
  (onSelect)="onDateChange($event)" inputId="icon">
</p-datepicker>